import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const OfferIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M14.528 7.197h-3.036c.007.1.013.2.011.304a1.241 1.241 0 0 1-1.25 1.196H5.506a.5.5 0 1 1 0-1h4.749a.246.246 0 0 0 .25-.236 2.253 2.253 0 0 0-2.25-2.263h-3.66a3.237 3.237 0 0 0-2.34-1H.256a.25.25 0 0 0-.25.25v5a.25.25 0 0 0 .138.223l4.732 2.366c.87.437 1.878.516 2.806.221l7.34-2.318a1.4 1.4 0 0 0 .975-1.486 1.452 1.452 0 0 0-1.468-1.257Z", fill: "currentColor" })));
});
OfferIcon.displayName = 'OfferIcon';
export default OfferIcon;
